<template>

<a-table :loading="loading">

	<router-view />

	<a-table-head v-if="items.length">

		<a-table-head-cell width="100px">Thumbnail</a-table-head-cell>
		<a-table-head-cell>Title/Description</a-table-head-cell>
		<a-table-head-cell width="200px">Tags</a-table-head-cell>
		<a-table-head-cell width="200px">Room</a-table-head-cell>
		<a-table-head-cell width="100px" class="featured-cell">Featured</a-table-head-cell>
		<a-table-head-cell width="100px" right="true">

			<router-link :to="{name: 'VideosCreate'}" class="avatar-add"><i class="fa fa-plus" /></router-link>

		</a-table-head-cell>

	</a-table-head>

	<a-table-row v-for="(item, index) in items" :key="index">

		<a-table-cell width="100px" :background="item.thumbnail"></a-table-cell>
		<a-table-cell>{{ item.title }} <small>{{ item.description }}</small></a-table-cell>
		<a-table-cell width="200px" class="tags">

			<a-tag v-for="(tag, index) in item.tags" :key="index" :tag="tag" />

			<template v-if="!item.tags.length">No tags.</template>

		</a-table-cell>
		<a-table-cell width="200px">

			<template v-if="item.room_id">{{ $store.getters['rooms'][item.room_id] }}</template>

			<template v-if="!item.room_id">No room.</template>

		</a-table-cell>
		<a-table-cell width="100px" class="featured-cell">

			<div class="featured" :class="{'is-active': item.featured}" v-on:click="onFeaturedClick(item.id, !item.featured)"><i class="fa fa-check-circle" /></div>

		</a-table-cell>
		<a-table-cell width="100px">

			<a-table-row-actions>

				<a-table-row-actions-item icon="pencil" text="Edit" v-on:click="onEditClick(item.id)" />
				<a-table-row-actions-item icon="trash" text="Delete" v-on:click="onDeleteClick(item.id)" />

			</a-table-row-actions>

		</a-table-cell>

	</a-table-row>

	<a-table-empty v-if="!items.length" :to="{name: 'VideosCreate'}" button="Add video">No videos added.</a-table-empty>

</a-table>

</template>

<script>

import axios from 'axios'

export default {

	data: function() {

		return {
			loading: true,
			items: []
		}

	},

	created: function() {

		this.fetch()

	},

	watch: {

		$path: function() {

			if (!this.$route.meta.modal) this.fetch()

		}

	},

	methods: {

		onFeaturedClick: function(id, value) {

			axios.patch('videos/' + id, {
				featured: value
			}).then(function() {	
				
				this.$_.each(this.items, function(item) {

					if (item.id === id) item.featured = value

				})

				this.loading = false

			}.bind(this))

		},

		onEditClick: function(id) {

			this.$router.push({
				name: 'VideosEdit',
				params: {
					id: id
				}
			})
			
		},

		onDeleteClick: function(id) {

			this.$router.push({
				name: 'VideosDelete',
				params: {
					id: id
				}
			})

		},

		fetch: function() {

			this.loading = true

			axios.get('videos').then(function(response) {		

				this.items = response.data
				this.loading = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.avatar-add {
	font-size: 18px;
	background-color: #5B108B;
	color: #fff;
	width: 32px;
	height: 32px;
	margin-top: 4px;
	display: inline-block;
	border-radius: 16px;
	text-align: center;
	line-height: 34px;
}

.featured-cell {
	display: flex;
	justify-content: center;
}

.featured {
	width: 32px;
	height: 24px;
	text-align: center;
	cursor: pointer;
	font-size: 24px;
	color: #ccc;
}

.featured.is-active {
	color: #5B108B;
}

.tags {
	display: flex;
	align-items: flex-start;
}

</style>
